import React from "react";

import _ from "underscore";
import $ from "jquery";

import ReactDOMServer from "react-dom/server";

import Modal from "shared/modal";

import SignalTypeBadges from "./SignalTypeBadges";

import containerTemplate from "./substitution_params_picker/templates/container.jst";
import alertTemplate     from "./substitution_params_picker/templates/alert.jst";
import searchTemplate    from "./substitution_params_picker/templates/search.jst";
import itemTemplate      from "./substitution_params_picker/templates/item.jst";
import categoryTemplate  from "./substitution_params_picker/templates/category.jst";
import sectionTemplate   from "./substitution_params_picker/templates/section.jst";

class FieldjQueryAdapter {
  constructor($el) {
    this.$el = $el;
  }

  get value() {
    return this.$el.val().trim();
  }

  get selection() {
    const start = this.$el[0].selectionStart;

    if (start) {
      return {
        start,
        end: this.$el[0].selectionEnd
      };
    } else {
      return null;
    }
  }

  update(value) {
    this.$el.val(value).trigger('change');
    this.$el.focus();
  }
}

export default class SubstitutionParamsPicker extends Modal {
  initialize({ field, columnsConfig, fieldType, pickerOptions } = {}) {
    if (!field) {
      throw new Error("Target field is required");
    }
    if (!columnsConfig) {
      throw new Error("Columns config is required");
    }

    if (field instanceof $) {
      this.field = new FieldjQueryAdapter(field);
    } else {
      // this object must implement the same interface as FieldjQueryAdapter
      this.field = field;
    }

    this.fieldType = fieldType || "json";
    this.columnsConfig = columnsConfig;
    this.pickerOptions = pickerOptions || this.defaultPickerOptions;
    this.pickerOptions.sections = this.pickerOptions.sections || [{ id: 'default', name: '', categories: '*', opened: true }];
    this.categoryToCssIdMap = {};
    this.categoryCssIndex = 0;

    // normalize the sections
    this.pickerOptions.sections = _.map(this.pickerOptions.sections, section => _.extend(section, { id: section.id || section.name.split(' ').join('-') }));
  }

  body() {
    return this.template();
  }

  render() {
    super.render();

    this._renderColumnSelection(this.columnsConfig);
    this.$(".modal-footer").hide();
    if (this.pickerOptions.searchable) {
      this.$('div.substitutionParamsContainer').before(this.searchTemplate());
    }
    return this;
  }

  // TODO: from TECH-1253 - Create a backdraft shared component that consolidates ActionTable's column picker and Webhook's substitution params picker - currently a lot of duplication!

  _renderColumnSelection(columnsConfig) {
    const selectorArea = this.$(".substitutionParamsContainer");
    selectorArea.empty();

    const visibleSections = _.select(this.pickerOptions.sections, section => _.any(columnsConfig, c => section.categories === '*' || _.contains(section.categories, c.category)));

    _.each(visibleSections, section => {
      selectorArea.append(this.sectionTemplate({
        section: section.name,
        sectionId: section.id,
        defaultOpen: section.opened
      }));
    });

    this._hideEmptySectionTitles(visibleSections);

    const orderedColumns = this._reorderRingPoolColumns(columnsConfig);
    this._renderColumnsInSection(orderedColumns, visibleSections, selectorArea);
  }

  _hideEmptySectionTitles(visibleSections) {
    if (visibleSections.length === 1) {
      this.$('.substitutionParam--section').find('.toggle-content-trigger').hide();
      this.$('.substitutionParam--section').find('.toggle-content').show();
    }
  }

  _reorderRingPoolColumns(columnsConfig) {
    const separatedRingPoolColumns = _.partition(columnsConfig, c => _.result(c, "category") === "RingPool Details");

    return separatedRingPoolColumns[1].concat(separatedRingPoolColumns[0]);
  }

  _renderColumnsInSection(columns, visibleSections, selectorArea) {
    _.each(columns, function(config) {
      if (config.id) {
        if (this.pickerOptions.categories) {
          this._renderColumnWithCategories(config, visibleSections);
        } else {
          selectorArea.addClass("withoutCategories row");
          this._renderColumn(config, selectorArea);
        }
      }
    }, this);
  }

  _renderColumn(config, selectorArea) {
    if (!this.$("ul").length) {
      selectorArea.append($("<div class='col-sm-12'><ul>"));
    }
    const ul = this.$("ul");
    let badges = "";
    if (config.signal_types && config.signal_types.length > 0) {
      const badgesElement = React.createElement(SignalTypeBadges, { signalTypes: config.signal_types });
      badges = ReactDOMServer.renderToString(badgesElement);
    }
    const li = $("<li>").html(this.itemTemplate({ title: config.title, id: config.id, badges }));
    ul.append(li);
    return li;
  }

  _renderColumnWithCategories(config, visibleSections) {
    const categoryId = this._categoryCssId(config.category);

    const section = _.find(
      visibleSections,
      section => section.categories === '*' || _.contains(section.categories, config.category)
    );

    const domContainer = this.$(`#section_${section.id}`);

    if (!this.$(`ul#${categoryId}`).length) {
      domContainer.append(this.categoryTemplate({
        category: config.category,
        category_id: categoryId
      }));
    }

    const category = this.$(`ul#${categoryId}`);
    let badges = "";
    if (config.signal_types && config.signal_types.length > 0) {
      const badgesElement = React.createElement(SignalTypeBadges, { signalTypes: config.signal_types });
      badges = ReactDOMServer.renderToString(badgesElement);
    }
    const li = $("<li>").html(this.itemTemplate({ title: config.title, id: config.id, badges }));
    category.append(li);
    return li;
  }

  _searchFields() {
    _.each(this.columnsConfig, function(column) {
      const queryRegex = new RegExp(this.$("input[name='substitution-param-search']").val(), "i"); // search for query case insensitive
      const match = column.title.search(queryRegex) > -1;
      const fieldEl = this.$(`a[data-title='${column.id}']`);
      match ? fieldEl.parent().show() : fieldEl.parent().hide();
    }, this);

    const sections = this.$('div.substitutionParam--section');
    sections.find('.toggle-content-trigger').addClass('down');
    sections.find('.toggle-content').show();
  }

  _pickSubstitutionParam(event) {
    event.preventDefault();

    const substitutionParam = this._formatValue(this.$(event.target).data("title"));
    const currentValue = this.field.value;

    const selection = this.field.selection;

    if (selection) {
      const startPos = selection.start;
      const endPos = selection.end;

      const subValue = currentValue.substring(0, startPos) + substitutionParam + currentValue.substring(endPos, currentValue.length);
      this.field.update(subValue);
    } else {
      this.field.update(currentValue + substitutionParam);
    }

    this.close();
  }

  _formatValue(value) {
    // This escaping is needed in case a substitution param contains a '.' in the name, we want to escape it so anything after the '.'
    // will not be treated as a method when validating on the server.
    const escapedValue = value.replace(/\./g, "\\.");
    switch (this.fieldType) {
    case "json":
      return `<${escapedValue}>`;
    case "xml":
      return `[${escapedValue}]`;
    }
  }

  _categoryCssId(category) {
    if (!this.categoryToCssIdMap[category]) {
      this.categoryToCssIdMap[category] = `category_${this.categoryCssIndex++}`;
    }
    return this.categoryToCssIdMap[category];
  }
}

_.extend(SubstitutionParamsPicker.prototype, {
  template: containerTemplate,
  alertTemplate,
  searchTemplate,
  itemTemplate,
  categoryTemplate,
  sectionTemplate,

  className: "modal-substitution-param-picker",

  defaultPickerOptions: {
    categories: true,
    searchable: true,
    sections:  [
      {
        name: "Marketing Data",
        categories: [
          "Signals",
          "Short Text Fields",
          "Long Text Fields",
          "Categories",
          "Revenue Per Signal",
          "Payment Details Per Signal"
        ],
        opened: true
      },
      {
        name: "Invoca Data",
        categories: "*",
        opened: true
      }
    ]
  },

  title: "Insert substitution parameter",

  size: "large",

  events: {
    "keyup input[name='substitution-param-search']": "_searchFields",
    "click a.substitution-param-item": "_pickSubstitutionParam"
  }
});
